import { colors } from "./colors";

/**
 * ค่าคงที่ของเมนู "เรียกคืนแผงค้า"
 *
 * สถานะแยกชุดกับเมนูคืนค่ามัดจำแผง เพราะโมดูลนี้ไม่มี CANCELED (ไม่มีฝั่งลูกค้าให้ยกเลิก)
 * ส่วนค่าที่เป็นกลางจริงๆ (เพดานไฟล์แนบ / สีสถานะสัญญา) re-export จากที่เดิม
 * เพื่อให้แก้ที่เดียว และหน้าเพจฝั่งนี้ไม่ต้องเอ่ยชื่อ DEPOSIT_REFUND เลย
 */
export {
  DEPOSIT_REFUND_REVIEW_ACCEPT as STALL_RECLAIM_REVIEW_ACCEPT,
  DEPOSIT_REFUND_REVIEW_MAX_FILES as STALL_RECLAIM_MAX_FILES,
  DEPOSIT_REFUND_REVIEW_MAX_FILE_SIZE as STALL_RECLAIM_MAX_FILE_SIZE,
  DEPOSIT_REFUND_REVIEW_MAX_NOTE_LENGTH as STALL_RECLAIM_MAX_NOTE_LENGTH,
  DEPOSIT_REFUND_DOC_REF_MAX_LENGTH as STALL_RECLAIM_DOC_REF_MAX_LENGTH,
  leaseStatusColor,
} from "./depositRefund";

/** สถานะคำสั่งเรียกคืนแผงค้า — DELETED ไม่เคยคืนมาใน API (soft delete) */
export enum STALL_RECLAIM_STATUS {
  WAITING = "WAITING",
  APPROVE = "APPROVE",
  NOT_APPROVE = "NOT_APPROVE",
}

/** ค่าพิเศษของตัวกรอง ไม่ได้ส่งไป backend (ไม่ส่ง status = ทั้งหมด) */
export const STALL_RECLAIM_STATUS_ALL = "ALL";

/** ค่าพิเศษของตัวกรองโซน/แผงค้า/ประเภทแผงค้า ไม่ได้ส่งไป backend */
export const STALL_RECLAIM_FILTER_ALL = "ALL";

/**
 * ห้ามใช้ t('STATUS.WAITING') จาก common.json เพราะที่นั่นแปลว่า "รอการชำระเงิน"
 * DELETED ใส่ไว้ด้วยแม้ไม่มีใน dropdown เผื่อ record เก่าที่ถูกลบหลุดมาในตาราง
 * จะได้โชว์คำไทย ไม่ใช่ค่าดิบจาก DB
 */
export const STALL_RECLAIM_STATUS_LABEL: Record<string, string> = {
  [STALL_RECLAIM_STATUS.WAITING]: "รอพิจารณา",
  [STALL_RECLAIM_STATUS.APPROVE]: "อนุมัติ",
  [STALL_RECLAIM_STATUS.NOT_APPROVE]: "ไม่อนุมัติ",
  DELETED: "ลบแล้ว",
  [STALL_RECLAIM_STATUS_ALL]: "ทั้งหมด",
};

/** สีตัวอักษรและจุดนำหน้าใน dropdown (ใช้ palette เดิมจาก constants/colors) */
export const STALL_RECLAIM_STATUS_COLOR: Record<string, string> = {
  [STALL_RECLAIM_STATUS.WAITING]: colors.lightOrange,
  [STALL_RECLAIM_STATUS.APPROVE]: colors.green,
  [STALL_RECLAIM_STATUS.NOT_APPROVE]: colors.red,
  DELETED: colors.gray,
  [STALL_RECLAIM_STATUS_ALL]: colors.gray,
};

/** พื้นหลัง chip ในตาราง — โทนอ่อนของสีเดียวกัน ให้ตัวอักษรยังอ่านออก */
export const STALL_RECLAIM_STATUS_BG: Record<string, string> = {
  [STALL_RECLAIM_STATUS.WAITING]: "rgba(240, 183, 96, 0.18)",
  [STALL_RECLAIM_STATUS.APPROVE]: "rgba(28, 185, 154, 0.14)",
  [STALL_RECLAIM_STATUS.NOT_APPROVE]: "rgba(176, 0, 32, 0.10)",
  DELETED: "rgba(108, 117, 125, 0.12)",
};

/** ลำดับที่ใช้ render dropdown ตัวกรองสถานะ — ไม่มี DELETED เพราะ API ไม่คืนมา */
export const STALL_RECLAIM_STATUS_OPTIONS: string[] = [
  STALL_RECLAIM_STATUS_ALL,
  STALL_RECLAIM_STATUS.WAITING,
  STALL_RECLAIM_STATUS.APPROVE,
  STALL_RECLAIM_STATUS.NOT_APPROVE,
];

/** ผลการพิจารณาที่เลือกได้ใน modal พิจารณา */
export const STALL_RECLAIM_REVIEW_OPTIONS: string[] = [
  STALL_RECLAIM_STATUS.APPROVE,
  STALL_RECLAIM_STATUS.NOT_APPROVE,
];

/** ป้ายของรายการใน log — คำต่างจากฝั่งคืนค่ามัดจำ ("คำสั่ง" ไม่ใช่ "คำร้อง") */
export const STALL_RECLAIM_LOG_ACTION_LABEL: Record<string, string> = {
  CREATE: "สร้างคำสั่ง",
  REVIEW: "พิจารณาคำสั่ง",
  CANCEL: "ยกเลิกคำสั่ง",
  DELETE: "ลบคำสั่ง",
};

/**
 * เลขที่คำสั่งที่เจ้าหน้าที่พิมพ์เอง — คอลัมน์เดียวกับ deposit_refund_no ของเมนูคืนค่ามัดจำ
 * จึง unique ข้ามทั้งสองโมดูล (พิมพ์ชนกับใบ DEP- จะได้ 400/409 กลับมา)
 * ความยาวยึดตามคอลัมน์ varchar(50) — รอ BE ยืนยันตัวเลขจริง
 */
export const STALL_RECLAIM_NO_MAX_LENGTH = 50;

/** รายละเอียดคำสั่ง (reason) — ใช้เพดานเดียวกับ note ของการพิจารณา */
export const STALL_RECLAIM_REASON_MAX_LENGTH = 5000;

/** สถานะที่ยังไม่รู้จัก ให้โชว์ค่าดิบไว้ก่อน ดีกว่าโชว์ "-" แล้วข้อมูลหายไปเฉยๆ */
export const stallReclaimStatusLabel = (status?: string) =>
  (status && STALL_RECLAIM_STATUS_LABEL[status]) || status || "-";

export const stallReclaimStatusColor = (status?: string) =>
  (status && STALL_RECLAIM_STATUS_COLOR[status]) || colors.gray;

export const stallReclaimStatusBg = (status?: string) =>
  (status && STALL_RECLAIM_STATUS_BG[status]) || colors.extraLightGray;
